import React from 'react';

interface IIcon {
  width?: number;
}

export const Icon: React.FC<IIcon> = () => null;
